<template>
    <div class="pages-403">
        <!-- <div class="flex items-center justify-center notice-txt fitness-red">
            对不起！您暂无此权限 <br>
            请联系管理员为您开通
        </div> -->
        <el-table border :data="tableData" style="width: 100%">
            <el-table-column :label="$t('Message.error')" align="center">
                <template slot-scope="{row}">
                    <div class="fitness-403-redItem">
                        {{ row.a1 }} <br>
                        {{ row.a2 }}
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            tableData: [
                {
                    a1: this.$t('Message.sorry_no_authority'),
                    a2: this.$t('Message.please_admin'),
                }
            ],
        };
    },
    created() {
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.pages-403 {
    padding: 25px;
    background: #fff;
    height: 100%;
}
.notice-txt {
    font-size: 20px;
    padding-top: 100px;
}
.fitness-403-redItem {
    color: #db093f;
}

</style>
